import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "styled-components";
import { createEmbeddingContext } from "amazon-quicksight-embedding-sdk";

import "react-datepicker/dist/react-datepicker.css";
// CSS Modules, react-datepicker-cssmodules.css//
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import packageInfo from "../../package.json";

import { applicationService, appUserService, t } from "../services";
import { strCode } from "../consts";
import { FlexContainers, GlobalStyle, Paragraph2, WrapperContainer } from "../components";
import { EmbeddingProvider } from "../hooks";
import Main from "./Main";
import LicensesListModal from "./Licenses/LicensesListModal";

const AppContainer = () => {
  const [initializationComplete, setInitializationComplete] = useState(false);
  const [licenseModalActive, setLicenseModalActive] = useState(false);

  const darkMode = useSelector((store) => store.global.darkMode);
  const cognitoUser = useSelector((store) => store.auth.cognitoUser);
  const markets = useSelector((store) => store.configs.marketIso);

  const embeddingContext = useRef(null);

  const showFooter = !cognitoUser || (!appUserService.isAdmin() && !markets);
  const version = `${t(strCode.VERSION_TITLE)} ${packageInfo?.version}`;
  const year = new Date().getFullYear();

  useEffect(() => {
    const initEmbeddingContext = async () => {
      if (!embeddingContext.current) {
        embeddingContext.current = await createEmbeddingContext();
      }
    };

    Promise.all([initEmbeddingContext(), applicationService.initApplication()]).then(() =>
      setInitializationComplete(true)
    );
  }, []);

  // Disable lodash access via window._ from the browser console
  useEffect(() => {
    window._ = null;
  }, []);

  return (
    <>
      <ThemeProvider
        theme={{
          darkMode: darkMode
        }}>
        <EmbeddingProvider value={embeddingContext.current}>
          <GlobalStyle darkMode={darkMode} cognitoUser={!showFooter} />
          {initializationComplete && <Main />}
          {showFooter && initializationComplete && (
            <footer>
              <WrapperContainer Container={FlexContainers.FlexRow} gap={20}>
                <Paragraph2>{t(strCode.COPYRIGHT_NOTICE, { year })}</Paragraph2>
                <Paragraph2
                  style={{ cursor: "pointer", textDecorationLine: "underline" }}
                  onClick={() => setLicenseModalActive(true)}>
                  {t(strCode.LICENSES)}
                </Paragraph2>
              </WrapperContainer>
              <Paragraph2>{version}</Paragraph2>
              <LicensesListModal active={licenseModalActive} setActive={setLicenseModalActive} />
            </footer>
          )}
          <Toaster position="top-center" reverseOrder={false} />
        </EmbeddingProvider>
      </ThemeProvider>
    </>
  );
};

export default AppContainer;
